export enum ServicesTypes {
  FE_DISTRIBUTIONS = "FE_DISTRIBUTIONS",
  LAMBDA = "LAMBDA",
  MICROSERVICES_CORE = "MICROSERVICES_CORE",
  MICROSERVICES_BE4FE = "MICROSERVICES_BE4FE",
}
